import * as Flux from 'dg-web-shared/lib/Flux';
import * as SettingsState from '../../common/state/SettingsState';
import * as TransactionsListState from '../state/TransactionsListState';
import { SlideIn } from '../../ui/slidein/SlideIn';
import { RunningCheckinByPlate } from './RunningCheckinByPlate';
import { TerminatedCheckinByPlate } from './TerminatedCheckinByPlate';
import { Translation } from 'dg-web-shared/lib/Text';
import { parkTransactionDetailTexts } from '../i18n/TransactionsListTexts';
import { SlideInPortalId } from '../../account/root/components/PortalSlidein';
import { Spinner } from 'dg-web-shared/ui/Spinner';

export interface ParkTransactionSlideInTexts {
    titleActiveTransaction: Translation;
    titleActiveTransactionDetail: Translation;

    titleExpiredTransaction: Translation;
}

const parkTransactionDetailContractExternalId = (store: Flux.Store) =>
    TransactionsListState.Detail.get(store).parkTransactionContractExternalId;

const texts = (p: { settings: SettingsState.State }) =>
    parkTransactionDetailTexts[p.settings.language];

const slideInTitle = (p: {
    parkTransactionDetail: TransactionsListState.CheckinByPlateDetailState.State;
    settings: SettingsState.State;
}) =>
    p.parkTransactionDetail.data
        ? p.parkTransactionDetail.data.isRunning
            ? texts(p).titleActiveTransaction()
            : texts(p).titleExpiredTransaction()
        : '';

const closeSlideIn = (store: Flux.Store) => {
    TransactionsListState.Detail.stateWrite(store, {
        parkTransactionContractExternalId: null,
    });
    return 'closeSlideIn';
};

export const CheckinByPlateSlideIn = Flux.selectState(
    store => {
        const contractExternalId =
            parkTransactionDetailContractExternalId(store);
        return {
            contractExternalId,
            settings: new SettingsState.StateSlice(store).state,
            transactionsListDetail: TransactionsListState.Detail.get(store),
            parkTransactionDetail:
                TransactionsListState.CheckinByPlateDetailState.get(
                    store,
                    contractExternalId ? { contractExternalId } : null,
                ),
        };
    },
    p => (
        <SlideIn
            title={slideInTitle(p)}
            open={!!p.contractExternalId}
            onClose={() => p.update(closeSlideIn)}
        >
            {p.parkTransactionDetail.pending &&
            !p.parkTransactionDetail.data ? (
                <Spinner />
            ) : !p.parkTransactionDetail.data ? null : p.parkTransactionDetail
                  .data.isRunning ? (
                <RunningCheckinByPlate
                    isPrimaryTransactionInParkCreate={false}
                    portal={SlideInPortalId.TRANSACTION_LIST}
                    transaction={p.parkTransactionDetail.data}
                />
            ) : (
                <TerminatedCheckinByPlate
                    transaction={p.parkTransactionDetail.data}
                />
            )}
        </SlideIn>
    ),
);
